module.exports = __webpack_public_path__ + "img/FECREDIT.63edc125.svg";